<template>
  <!-- 信息补充 -->
  <div class="replenishmentRegistration">
    <!--信息补充弹窗 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <div class="dialog-content">
        <el-form :model="datas" :rules="rules" ref="form" label-width="120px">
          <!-- 订单号 -->
          <el-form-item :label="$t('message.orderNumber')" prop="order_sn" v-if="isAdd">
            <el-input v-model="datas.order_sn" placeholder="请输入订单编号" @blur="purchaseAddGetOrderDetailOptions" />
          </el-form-item>
          <!-- 订单详情ID -->
          <el-form-item :label="$t('message.orderDetailId')" prop="order_detail_id" v-if="isAdd">
            <el-select v-model="datas.order_detail_id" placeholder="请选择订单详情ID" multiple style="width: 100%;">
              <el-option v-for="item in orderDetail" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </el-form-item>
          <!-- 原交易号 -->
          <el-form-item label="原交易号" prop="origin_purchase_nos">
            <el-select v-model="datas.origin_purchase_nos" placeholder="请选择原交易号" multiple style="width: 100%;">
              <el-option v-for="item in origin_purchase" :key="item.purchase_no" :label="item.purchase_no"
                :value="item.purchase_no" />
            </el-select>
          </el-form-item>
          <!-- 补买交易号 -->
          <el-form-item :label="$t('message.replenishmentTransactionNumber')" prop="purchase_no">
            <el-input v-model="datas.purchase_no" placeholder="请输入采购单号" />
          </el-form-item>
          <!-- 详细说明 -->
          <el-form-item :label="$t('message.detailedExplanation')" prop="desc">
            <el-input v-model="datas.desc" placeholder="请输入详细说明 " type="textarea" />
          </el-form-item>
          <!--沟通截图  -->
          <el-form-item :label="$t('message.communicationScreensho')">
            <div class="image">
              <div v-for="(item, index) in datas.images" :key="index" class="image-item">
                <img :src="item" class="avatar" />
                <i class="el-icon-error" @click="removeImage(index)"></i>

              </div>
              <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false" list-type="picture-card"
                :before-upload="beforeAvatarUpload" :http-request="httpup" multiple>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <!-- 是否内部赔款 -->
          <el-form-item :label="$t('message.isInternalClaim')" prop="is_reparation">
            <el-radio-group v-model="datas.is_reparation">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 赔款单号 -->
          <el-form-item :label="$t('message.claimNumber')" prop="reparation_sn">
            <el-input v-model="datas.reparation_sn" placeholder="请输入赔款单号" />
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer" class="dialog-footer">
        <!-- 登记 -->
        <el-button type="primary" v-if="isAdd" @click="purchaseAddStore">{{ $t('message.registration') }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" v-else @click="purchaseAddUpdate">{{ $t('message.save') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      dialogVisible: false,
      title: '',
      isAdd: true,
      datas: {
        order_sn: '',
        order_detail_id: [],
        purchase_no: '',
        amount: '',
        reason: '',
        desc: '',
        images: [],
        is_reparation: 0,
        reparation_sn: '',
        origin_purchase_nos: []
      },
      // 订单详情ID
      orderDetail: [],
      origin_purchase: [],//原交易号
      rules: {
        order_sn: [{ required: true, message: '请输入订单编号', trigger: 'blur' }],
        order_detail_id: [{ required: true, message: '请输入订单详情ID', trigger: 'blur' }],
        purchase_no: [{ required: true, message: '请输入采购单号', trigger: 'blur' }],
        origin_purchase_nos: [{ required: true, message: '请输入原交易号', trigger: 'blur' }],
      }
    }
  },
  methods: {
    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    },
    // 提交补充信息
    submitAudit() {
      // 处理补充信息提交逻辑
      this.closeDialog();
    },
    // 上传沟通截图成功
    handleAvatarSuccess(res, file) {
      this.datas.images.push(res.url);
    },
    // 订单详情ID
    purchaseAddGetOrderDetailOptions() {
      if (!this.datas.order_sn) {
        this.$message.error('请输入订单编号');
        return;
      }
      this.orderDetail = []
      this.$api.financialApi.purchaseAddGetOrderDetailOptions({
        order_sn: this.datas.order_sn
      }).then(res => {
        this.orderDetail = res.data
      });
      this.getOriginPurchaseNoOptions()
    },
    // 原交易号选项
    getOriginPurchaseNoOptions() {

      this.$api.financialApi.getOriginPurchaseNoOptions({
        order_sn: this.datas.order_sn
      }).then(res => {
        this.origin_purchase = res.data

      });
    },
    // 删除沟通截图
    removeImage(index) {
      this.datas.images.splice(index, 1);
    },
    // 上传沟通截图前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isSVG = file.type === 'image/svg+xml';
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error('上传沟通截图只能是 JPG/PNG/SVG 格式!');
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传沟通截图
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.datas.images.push(data.data)
    },
    // 登记
    purchaseAddStore() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.financialApi.purchaseAddStore(this.datas).then(res => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.purchaseAddList();
          });
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },
    // 更新
    purchaseAddUpdate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.financialApi.purchaseAddUpdate(this.datas).then(res => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.purchaseAddList();
          });
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    }

  }
}
</script>
<style lang='scss' scoped>
.replenishmentRegistration {
  padding: 24px;
  background-color: #fff;
}

.dialog-content {
  padding: 0 24px;

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }
}

.title {
  margin-bottom: 24px;
}

.avatar-uploader {
  height: 80px;
  width: 80px;
}

/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}
</style>